// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"416":"24abe3d9","587":"fd6c7d0b","834":"2cb1c674"}[chunkId] + ".css";
};